export default __webpack_public_path__ + "locales/zh-CN/SharingPanel.json?hash=b88e1df19e09ca387b157842aa9fec02";